import { useContext } from 'react';
import { PhoneLockContext } from './provider';

export function usePhoneLock() {
  const context = useContext(PhoneLockContext);

  if (!context) throw new Error('usePhoneLock must be used within the PhoneLockContext');

  return context;
}
